<template>
  <div class="hello">
      <b-button :pressed="this.selected_mode === 'analyse'" v-on:click="change_mode('analyse')" variant="success">アナリーゼ</b-button>
      <b-button :pressed="this.selected_mode === 'code'" v-on:click="change_mode('code')" variant="success">和音とコード</b-button>
      <div class="img-guard"><span class="guard-nopic"></span>
        <img :src='this.img1' width="100%"/>
      </div>
      <div class="img-guard"><span class="guard-nopic"></span>
        <img :src='this.img2' width="100%"/>
      </div>

  </div>
</template>

<script>
  import {Burg18Books} from '../variables.js'

  export default {
    name: 'Score',
    data () {
      return {
      selected_piece: '',
      selected_mode: 'analyse',
      img1:'',
      img2:'',
      books: Burg18Books
    }
    },
    mounted: function () {
      this.selected_piece = this.books[this.$route.params.id -1]
      this.get_score_images()
    },
    methods: {
        get_score_images: function() {
          if (this.selected_mode === 'code') {
              this.img1 = this.selected_piece.code_image1
            this.img2 = this.selected_piece.code_image2
          } else {
              this.img1 = this.selected_piece.analyse_image1
            this.img2 = this.selected_piece.analyse_image2
        }
      },
      change_mode: function(mode) {
          this.selected_mode = mode
          this.get_score_images()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .btn {
    background-color: #b0cbad;
    border-color: #b0cbad;
  }

  .img-guard{
    position:relative;
  }
  .guard-nopic{
    position:absolute;
    display:block;
    width:100%;
    height:100%;
    background: url(../guard.png);
  }

</style>



// WEBPACK FOOTER //
// src/components/Score.vue